exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.toolbarFilters {\n  padding-top: 10px;\n}\n.v-toolbar__content {\n  padding-left: 16px;\n}\n.headerList {\n  font-size: large;\n  text-align: center;\n}\n.clicked {\n  background: #d5e5f6;\n}\n", ""]);

// exports
